export default __webpack_public_path__ + "static/media/Hindi_ef_1.57633202.mp3";